module.exports = __webpack_public_path__ + "assets/96e80000f2e0de789ac2dc04a46573c8.png";